import { Component, OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router'
import {HttpClient,HttpParams,HttpResponse,HttpHeaders} from '@angular/common/http';
import {CommonService} from '../../common.service'
import { environment as configs } from 'src/environments/environment';
import * as $ from 'jquery';
declare var Swal;
@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.css']
})




export class RefundComponent implements OnInit {
   host=configs['ApiHost'];
   penddingTransections:any=[]
   constructor(private activeRoute:ActivatedRoute,private httpClient:HttpClient,private router:Router,public CSF:CommonService) {  this.CSF.setNavs(true); }

   ngOnInit() {
      this.CSF.setNavs(true);
   		this.getpendingpayments().then((resp)=>{
   				this.penddingTransections=resp['data'];

   		})
   }


   isReversal(rec){
   	let diff=new Date().getTime()-new Date(rec.createddate).getTime()
   	let h=parseInt((diff/(60*60*1000)).toString());
   	// console.log(h);
   	 return h<24;
   }



   // get list of pending payments
   getpendingpayments(){
  		return this.httpClient.get(this.host+'/csc/get/refund-record').toPromise()
   }


   	/*payagain(challanid){
   		 $('#vlechallanid').val(challanid);
  		$('#vlepay').submit();
   	}*/

    initRefund(itm){
       this.httpClient.post(this.host+'/csc/init/refund',{itm:itm},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
         //console.log(resp)
         if(resp['status']==true){
           //alert('here')
           Swal.fire({
                            type: 'success',
                            title: 'Refund Initiated Successfully'

                        })
           //this.payagain(challanid);
         }else{
           // this.router.navigate(['/payment/receipt/'+challanid])
         }
       })
    }

     initreversal(itm){
     	this.httpClient.post(this.host+'/csc/init/reversal',{itm:itm},{headers:new HttpHeaders({'Access-Control-Allow-Credentials':'true'}), withCredentials:true}).subscribe(resp=>{
         //console.log(resp)
         if(resp['status']==true){
           //alert('here')
           Swal.fire({
                            type: 'success',
                            title: 'Reversal Initiated Successfully'

                        })
           //this.payagain(challanid);
         }else{
           // this.router.navigate(['/payment/receipt/'+challanid])
         }
       })
     }

}
